import { StatusCountActionTypes } from "./status-count.types";

export const fetchStatusCountStart = (payload: any) => ({
  type: StatusCountActionTypes.FETCH_STATUS_COUNT_START,
  payload,
});

export const fetchStatusCountSuccess = (statusCount: any) => ({
  type: StatusCountActionTypes.FETCH_STATUS_COUNT_SUCCESS,
  payload: statusCount,
});

export const fetchStatusCountFailure = (error: any) => ({
  type: StatusCountActionTypes.FETCH_STATUS_COUNT_FAILURE,
  payload: error,
});

export const fetchStatusCountChanged = () => ({
  type: StatusCountActionTypes.FETCH_STATUS_COUNT_CHANGED,
});

export const fetchStatusCountReset = () => ({
  type: StatusCountActionTypes.STATUS_COUNT_RESET,
});

export const fetchAgentsStart = (payload: any) => ({
  type: StatusCountActionTypes.FETCH_AGENTS_START,
  payload: payload,
});

export const fetchAgentsSuccess = (agents: any) => ({
  type: StatusCountActionTypes.FETCH_AGENTS_SUCCESS,
  payload: agents,
});

export const fetchAgentsFailure = (error: any) => ({
  type: StatusCountActionTypes.FETCH_AGENTS_FAILURE,
  payload: error,
});

export const fetchAgentsChanged = () => ({
  type: StatusCountActionTypes.FETCH_AGENTS_CHANGED,
});

export const fetchAgentsReset = () => ({
  type: StatusCountActionTypes.AGENTS_LIST_RESET,
});
